// /src/pdf/builders/tsl/buildDoc.js
const stripCalendar = (text) => (text || "").replace(/^📅\s*/u, "").trimStart();

export function buildTslDoc({
  t, shortcode, stationName,
  period, date1,
  labels, data, avg, start, end, totalSessions,
  fmtNumber, locale,
  logoDataUrl,
  chartDataUrl,
  serviceName
}) {
  const content = [];
  const stationTitle = stationName || shortcode || '';
  const serviceTitle = serviceName || (t && t('tsl.title')) || '';

  // логотип слева
  if (logoDataUrl) {
    content.push({ image: logoDataUrl, width: 140, margin: [0, 0, 0, 10] });
  }

  // заголовок + период
  content.push(
    ...(serviceTitle ? [{ text: serviceTitle, style: 'h1', margin: [0, 0, 0, 2] }] : []),
    ...(stationTitle ? [{ text: stationTitle, style: 'h1', margin: [0, 0, 0, 4] }] : []),
    {
      margin: [0, 0, 0, 6],
      fontSize: 10,
      color: '#666',
      text: period === 'day' ? `${stripCalendar(t('tsl.date_label_day'))} ${date1}` : `${stripCalendar(t('tsl.date_label_last'))} ${date1}`
    },
    {
      text: (t && t('pdf.made_on')) || 'Report made on Radiomonitor.net',
      fontSize: 10,
      color: '#666',
      margin: [0, 0, 0, 10],
    }
  );

  // график (если есть)
  if (chartDataUrl) {
    content.push({
      image: chartDataUrl,
      width: 520,
      margin: [0, 0, 0, 10]
    });
  }

  // инфоблок как на странице (локализовано)
  if (totalSessions > 0) {
    content.push({
      margin: [0, 4, 0, 0],
      stack: [
        {
          text: `${t('tsl.avg_prefix')} ${fmtNumber(avg, locale)} ${t('tsl.minutes')}`,
          bold: true
        },
        { text: t('tsl.formula') },
        { text: t('tsl.period', { start, end, count: totalSessions, keySeparator: false }) }
      ],
      fontSize: 10.5
    });
  } else {
    content.push({ text: t('tsl.no_data'), fontSize: 11, bold: true });
  }

  return {
    pageSize: 'A4',
    pageMargins: [24, 28, 24, 36],
    footer: (current, totalPages) => ({
      margin: [24, 0, 24, 12],
      fontSize: 9,
      columns: [
        { text: `${(t && t('pdf.made_on')) || 'Report made on Radiomonitor.net'}`, alignment: 'left' },
        { text: `${current} / ${totalPages}`, alignment: 'right' },
      ],
    }),
    content,
    styles: {
      h1: { fontSize: 18, bold: true },
    },
  };
}

export { buildTslDoc as default };
